import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {ChildService} from "../../../../components/child/child.service";
import {MatSelectChange} from "@angular/material/select";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {DatePipe} from "@angular/common";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {FullChild} from "../../../../interfaces/FullChild";

@Component({
  selector: 'app-birthday-reports',
  templateUrl: './birthday-reports.component.html',
  styleUrls: ['./birthday-reports.component.scss']
})
export class BirthdayReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  centres$: Observable<Centre[]>;
  selectedCentre="All";
  displayedColumns: string[] = ['firstname', 'lastname',  'dob','dobDate', 'dobMonth', 'age', 'centreName', 'state', 'city'];
  dataSource: any;
  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private mStartDate!: Date;
  private mEndDate!: Date;
  fileName = 'Birthday_Report.xlsx';

mAllData:any[]=[]
  constructor(private mCentreService: CentreService, private readonly mFirestore: AngularFirestore, private mChildService: ChildService) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.dataSource = new MatTableDataSource<any>()
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;

  }

  ngOnInit(): void {
  //   this.mFirestore.collection<FullChild>('ALChild',
  //     ref => ref.orderBy("dob","desc"))
  //     .valueChanges().subscribe(res => {
  //       const today = new Date();
  //       this.dataSource.data = res
  //
  //       this.dataSource.sort = this.sort!;
  //       this.dataSource.paginator = this.paginator!;
  //
  //
  //       console.log(this.dataSource);
  // })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  showData($event: MatSelectChange) {
    this.selectedCentre =$event.value
  let q= this.mFirestore.collection<FullChild>('ALChild',ref => ref.orderBy('dob',"desc")
          .where('centreCode','==',this.selectedCentre)
          .where('isAlloted','==',true)
      )
    if(this.selectedCentre =="All") {
      q = this.mFirestore.collection<FullChild>('ALChild', ref => ref.orderBy('dob', "desc")
          .where('isAlloted','==',true))

      q.valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(res => {
        const today = new Date();

        this.mAllData = res.map(child => {
          const dob = child.dob; // Assuming "dob" is a Date object
          const dobMonth = dob.toDate().toLocaleString("en-US", { month: 'long' });
          const dobDate = dob.toDate().getDate();
          return {
            ...child,
            dobMonth,
            dobDate,

          }
        });
        this.dataSource.data = this.mAllData
        this.dataSource.sort = this.sort!;
        this.dataSource.paginator = this.paginator!;


        console.log(this.dataSource);
      });

    }
    else   if(this.selectedCentre !="All"){
      q = this.mFirestore.collection<FullChild>('ALChild', ref => ref
        .orderBy("dob", "desc")
          .where('isAlloted','==',true)
        .where('centreCode', '==', this.selectedCentre))
      q.valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(res => {
        // Transform the data to include "date of birth month" and "date of birth"
         this.mAllData = res.map(child => {
          const dob = child.dob; // Assuming "dob" is a Date object
          const dobMonth = dob.toDate().toLocaleString("en-US", { month: 'long' });
          const dobDate = dob.toDate().getDate();
          return {
            ...child,
            dobMonth,
            dobDate,

          }
        });

        // const today = new Date();
        this.dataSource.data = this.mAllData
        this.dataSource.sort = this.sort!;
        this.dataSource.paginator = this.paginator!;


        console.log(this.dataSource);
      });

    }

  }

  getDaysToBirthday(today: Date, dobDate: Date): number {
    const currentYear = today.getFullYear();
    const birthDate = new Date(dobDate);
    birthDate.setFullYear(currentYear);

    if (birthDate < today) {
      birthDate.setFullYear(currentYear + 1);
    }

    const diffTime = Math.abs(birthDate.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  starDate($event: any) {
    const startDate = $event.value;
    this.mStartDate = startDate

  }

  endDate($event: any) {
    const endDate = $event.value;
    this.mEndDate = endDate
    this.filterDataByDateRange(this.mStartDate, this.mEndDate);

  }

  filterDataByDateRange(mStartDate: Date, mEndDate: Date) {
    this.dataSource.data = this.dataSource.data.filter((x: FullChild) => {
      const dobDate = x.dob.toDate();
      return dobDate >= mStartDate && dobDate <= mEndDate;
    });

    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
  }

  onMonthChange($event: MatSelectChange) {
    this.dataSource.data =this.mAllData
    this.dataSource.data= this.dataSource.data.filter((x:any)=>x.dobMonth==$event.value)
  }
  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    //@ts-ignore
    this.dataSource.sortingDataAccessor = (data, sortHeaderId) => {
      if (sortHeaderId === 'dobMonth') {
        // Assuming 'dob' is the property with the Date object
        return data.dob.toDate().getMonth(); // Return the month (0-11) for sorting
      }
      return data[sortHeaderId];
    };
  }


}
